import { useTheme } from "@amx/ux-twoui-theming";
import { Stack } from "@fluentui/react";
import React from "react";
import { NoHrefLink, NoHrefLinkProps } from "../../Links/NoHrefLink/NoHrefLink";
import { StackItem } from "../../Stacks/Stack/Stack";

export interface ShowMoreButtonProps extends NoHrefLinkProps {
    /** Minimum height for the show link button. Defaults to defaultCellMinHeight */
    readonly minHeight?: string;
}

const defaultShowMoreHeight = "44px";

export const ShowMoreButton: React.FC<ShowMoreButtonProps> = ({ minHeight = defaultShowMoreHeight, ...props }) => {
    const theme = useTheme();

    return (
        <Stack verticalAlign="center" style={{ backgroundColor: theme.palette.neutralHigh, minHeight, padding: "0 16px" }}>
            <StackItem>
                <NoHrefLink {...props} />
            </StackItem>
        </Stack>
    );
};
